<template>
  <div class="contact-content">
    <h2 class="global-title">{{ $t('mbs-select-Contact') }}</h2>

    <!-- <div class="call-us" v-if="phone">
      <h2 class="title">{{ $t('mbs-call-us') }}</h2>
      <p class="desc">{{ $t('mbs-contact-us') }}</p>
      <a class="phone" :href="callPhone">{{ phone.value }}</a>
    </div> -->

    <div class="email-us">
      <h2 class="title">{{ $t('mbs-email-us') }}</h2>
      <div class="desc">
        <!-- <i18n-t keypath="mbs-email-desc" tag="p">
          <router-link class="email" to="/faqs">
            {{ $t('faqs') }}
          </router-link>
          <a class="email" :href="emailAddress">
            {{ $t('mbs-email-us') }}
          </a>
          <a class="email" :href="emailAddress">
            {{ $t('mbs-email-address') }}
          </a>
        </i18n-t> -->
        <i18n-t keypath="freshdesk-desc1" tag="p">
          <router-link class="email" to="/faqs">{{ $t('faqs') }}</router-link>
        </i18n-t>
      </div>
    </div>
    <div class="form-container">
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="subject">{{ $i18n.t('freshdesk-form-subject') }}*</label>
        </div>
        <div class="form-item-component">
          <Select
            name="subject"
            :errStatus="enquiryFormValidate.subject"
            role="select subject"
            v-model="enquiryFormData.enSubject"
            :options="subjectOptions"
            @change="handleValueChange($event, 'subject')"
          />
        </div>
        <p class="err-msg" v-if="enquiryFormValidate.subject">
          {{ $i18n.t('freshdesk-form-subject-msg') }}
        </p>
      </div>
      <div class="form-item-group" v-if="enquiryFormData.enSubject">
        <div class="form-item-label">
          <label for="subject">{{ $i18n.t('freshdesk-form-reason') }}*</label>
        </div>
        <div class="form-item-component">
          <Select
            name="reason"
            :errStatus="enquiryFormValidate.reason"
            role="select reason"
            v-model="enquiryFormData.enReason"
            :options="reasonOptions"
            @change="handleValueChange($event, 'reason')"
          />
        </div>
        <p class="err-msg" v-if="enquiryFormValidate.reason">
          {{ $i18n.t('freshdesk-form-reason-msg') }}
        </p>
      </div>
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="enquiry">{{ $i18n.t('freshdesk-form-enquiry') }}*</label>
          <span class="textarea-count">{{ enquiryFormData.enquiry.length }}/1500</span>
        </div>
        <div class="form-item-component">
          <textarea
            name="enquiry"
            class="form-textarea fs-mask"
            rows="8"
            maxlength="1500"
            :class="{ 'textarea-err': enquiryFormValidate.enquiry }"
            role="input enquiry"
            v-model.trim="enquiryFormData.enquiry"
            @input="handleValueChange($event, 'enquiry')"
          />
        </div>
        <p class="err-msg" v-if="enquiryFormValidate.enquiry">
          {{ $i18n.t('freshdesk-form-enquiry-msg') }}
        </p>
      </div>
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="email">{{ $i18n.t('freshdesk-form-email') }}*</label>
        </div>
        <div class="form-item-component">
          <input
            name="email"
            class="form-input fs-mask"
            :class="{
              'input-err': enquiryFormValidate.emailEmpty || enquiryFormValidate.emailValid,
            }"
            role="input email"
            v-model.trim="enquiryFormData.email"
            @input="handleValueChange($event, 'email')"
          />
        </div>
        <p class="err-msg" v-if="enquiryFormValidate.emailEmpty">
          {{ $i18n.t('freshdesk-form-email-msg1') }}
        </p>
        <p class="err-msg" v-if="enquiryFormValidate.emailValid">
          {{ $i18n.t('freshdesk-form-email-msg2') }}
        </p>
      </div>
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="subject">{{ $i18n.t('freshdesk-form-attachment') }}</label>
        </div>
        <div class="form-item-component">
          <FileUpload
            name="attachment"
            :errStatus="
              fileValidate.fileTypeErr || fileValidate.fileSizeErr || fileValidate.fileEnableErr
            "
            role="upload attachment"
            v-model="enquiryFormData.attachment"
            @change="handleValueChange($event, 'attachment')"
            :acceptFileType="acceptFileType"
          />
        </div>
        <p class="err-msg" v-if="fileValidate.fileTypeErr">
          {{ $i18n.t('freshdesk-upload-msg1') }}
        </p>
        <p class="err-msg" v-if="fileValidate.fileSizeErr">
          {{ $i18n.t('freshdesk-upload-msg2') }}
        </p>
        <p class="err-msg" v-if="fileValidate.fileEnableErr">
          {{ $i18n.t('freshdesk-upload-msg3') }}
        </p>
      </div>
      <div class="form-item-group">
        <div class="recaptcha"></div>
        <p class="err-msg" v-if="enquiryFormValidate.recaptcha">
          {{ $i18n.t('freshdesk-form-recaptcha') }}
        </p>
      </div>
      <button @click="sendForm" role="button" class="send-btn">
        {{ $t('freshdesk-send-btn') }}
      </button>
    </div>
    <Modal
      :title="$t('freshdesk-send-success-title')"
      :open="successModalVisible"
      :okText="$t('ok')"
      @onOk="sentConfirm"
    >
      <template #content>
        <div style="margin-bottom: 20px">
          {{ $t('freshdesk-send-success-text1') }}
        </div>
        <div>
          <i18n-t keypath="freshdesk-send-success-text2" tag="p">
            <span style="font-weight: bolder; cursor: pointer" @click="goToFaqs">{{
              $t('faqs')
            }}</span>
          </i18n-t>
        </div>
      </template>
    </Modal>
    <Modal
      :title="$t('freshdesk-send-fail-title')"
      :open="failModalVisible"
      :okText="$t('ok')"
      @onOk="failModalVisible = !failModalVisible"
    >
      <template #content>
        <div>{{ $t('freshdesk-send-fail-text') }}</div>
      </template>
    </Modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import { decryptAES } from '@/utils';
  import Select from '@/views/EnquiryForm/Select.vue';
  import Modal from '@/views/EnquiryForm/Modal.vue';
  import FileUpload from '@/views/EnquiryForm/FileUpload.vue';

  export default {
    name: 'Contact',
    components: { Select, Modal, FileUpload },
    computed: {
      ...mapState(['userInfo']),
      acceptFileType() {
        const tempArr = this.allowFileTypeArray.map(item => {
          return `.${item}`;
        });
        return tempArr.join(',');
      },
    },

    data() {
      return {
        phone: '',
        emailAddress: '',
        callPhone: '',
        successModalVisible: false,
        failModalVisible: false,
        enquiryFormData: {
          // firstname: '',
          // lastname: '',
          subject: '',
          enSubject: '',
          reason: '',
          enReason: '',
          enquiry: '',
          email: '',
          // membershipNo: '',
          attachment: [],
        },
        enquiryFormValidate: {
          // firstname: false,
          // lastname: false,
          subject: false,
          reason: false,
          enquiry: false,
          emailEmpty: false,
          emailValid: false,
          // membershipNo: false,
          // recaptcha: false,
        },
        fileValidate: {
          fileTypeErr: false,
          fileSizeErr: false,
          fileEnableErr: false,
        },
        allowFileTypeArray: [
          'pdf',
          'doc',
          'docx',
          'jpg',
          'jpeg',
          'png',
          'gif',
          'bmp',
          'heif',
          'webp',
          'raw',
          'tiff',
        ],
        subjectList: [],
        subjectOptions: [],
        reasonOptions: [],
        projectId: {
          local: '200',
          test: '200',
          uat: '156',
          production: '48',
        },
      };
    },
    mounted() {
      // this.getByType();
      this.enquiryFormData.email = this.userInfo.email;
      this.$http.common
        .getProjectSubjectList({
          lang: this.$i18n.locale,
          projectId: this.projectId[process.env.VUE_APP_CUSTOM_ENV],
          region: 'canada',
        })
        .then(res => {
          if (res.state === '11') {
            this.subjectList = res.payload;
            this.subjectOptions = res.payload.map(item => {
              return {
                label: item.name,
                value: item.enName,
              };
            });
          } else {
            this.$messageModal.show({
              image: false,
              closeIcon: true,
              desc: res.note,
              confirmBtn: 'ok',
              justHide: true,
              i18nNeed: false,
            });
            this.subjectList = [];
            this.subjectOptions = [];
          }
        });
    },
    methods: {
      getByType() {
        const data = {
          userId: this.userInfo.userId,
          type: 'profile',
          lang: this.$i18n.locale,
        };
        this.$http.member
          .getByType(data)
          .then(async res => {
            if (res?.state === '11') {
              this.phone = res.data.find(item => {
                return item.isEmail === 0;
              });
              this.callPhone = `tel:${this.phone?.value}`;
              const dragoncard = await this.getDragonCard();
              if (dragoncard?.state === '11') {
                this.emailAddress = `mailto:${
                  res.data.find(item => {
                    return item.isEmail === 1;
                  }).value
                }?subject=Enquiry or Feedback ${dragoncard.card.dragoncode.replace(
                  /(\d{4})/g,
                  '$1 ',
                )}`;
              } else {
                console.error(dragoncard?.note);
              }
            } else {
              console.error(res?.error);
            }
          })
          .catch(error => {
            console.error(error);
          });
      },

      getDragonCard() {
        const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
        const dragonCardData = {
          lang: this.$i18n.locale,
          device: 'web',
          version: '1.0.0',
          userId: this.userInfo.userId,
          sessionId: this.userInfo.sessionId,
          deviceName,
        };

        return this.$http.login.getDragonCard(dragonCardData);
      },
      goToFaqs() {
        this.$router.push({
          name: 'Faqs',
        });
      },
      sentConfirm() {
        this.successModalVisible = !this.successModalVisible;
        this.enquiryFormData = {
          // firstname: '',
          // lastname: '',
          subject: '',
          enSubject: '',
          reason: '',
          enReason: '',
          enquiry: '',
          email: '',
          // membershipNo: '',
          attachment: [],
        };
        this.enquiryFormValidate = {
          subject: false,
          reason: false,
          enquiry: false,
          emailEmpty: false,
          emailValid: false,
        };
        this.fileValidate = {
          fileTypeErr: false,
          fileSizeErr: false,
          fileEnableErr: false,
        };
      },
      handleValueChange(e, type) {
        switch (type) {
          // case 'firstname': {
          //   this.enquiryFormValidate.firstname = !e.target.value;
          //   break;
          // }
          // case 'lastname': {
          //   this.enquiryFormValidate.lastname = !e.target.value;
          //   break;
          // }
          case 'subject': {
            this.enquiryFormValidate.subject = !e;
            this.enquiryFormData.enSubject = e;
            this.enquiryFormData.subject = this.subjectOptions.find(
              item => item.value === e,
            )?.label;
            this.enquiryFormData.reason = '';
            // this.enquiryFormValidate.reason = true;
            this.reasonOptions = this.subjectList
              .find(item => item.enName === e)
              ?.fdSecondCategoryList.map(sitem => {
                return {
                  label: sitem.name,
                  value: sitem.enName,
                };
              });
            break;
          }
          case 'reason': {
            this.enquiryFormValidate.reason = !e;
            this.enquiryFormData.enReason = e;
            this.enquiryFormData.reason = this.reasonOptions.find(item => item.value === e)?.label;

            break;
          }
          case 'enquiry': {
            this.enquiryFormValidate.enquiry = !e.target.value;
            break;
          }
          case 'email': {
            this.enquiryFormValidate.emailEmpty = !e.target.value;
            if (e.target.value) {
              const emailReg =
                /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
              this.enquiryFormValidate.emailValid = !emailReg.test(e.target.value);
            } else {
              this.enquiryFormValidate.emailValid = false;
            }
            break;
          }
          // case 'membershipNo': {
          //   const newValue = formatCardNo(e.target.value);
          //   this.enquiryFormData.membershipNo = newValue;
          //   this.enquiryFormValidate.membershipNo = !!newValue && newValue.length !== 19;
          //   break;
          // }
          case 'attachment': {
            this.fileValidate.fileTypeErr = false;
            this.fileValidate.fileSizeErr = false;
            const fileList = e;
            const tempFileList = [];
            fileList.forEach(file => {
              const fileSize = file.size / 1024 / 1024;
              // 获取文件后缀
              const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
              // 校验文件类型
              if (!this.allowFileTypeArray.includes(fileType)) {
                this.fileValidate.fileTypeErr = true;
                return;
              }
              if (fileSize > 5) {
                this.fileValidate.fileSizeErr = true;
                return;
              }
              tempFileList.push(file);
            });
            this.enquiryFormData.attachment = tempFileList;
            break;
          }
          default:
            break;
        }
      },
      sendForm() {
        // 校验
        const {
          // firstname,
          // lastname,
          subject,
          enSubject,
          reason,
          enReason,
          enquiry,
          email,
          // membershipNo,
          attachment,
        } = this.enquiryFormData;
        // if (!firstname) {
        //   this.enquiryFormValidate.firstname = true;
        // }
        // if (!lastname) {
        //   this.enquiryFormValidate.lastname = true;
        // }
        if (!subject) {
          this.enquiryFormValidate.subject = true;
        }
        if (!reason) {
          this.enquiryFormValidate.reason = true;
        }
        if (!enquiry) {
          this.enquiryFormValidate.enquiry = true;
        }
        if (!email) {
          this.enquiryFormValidate.emailEmpty = true;
        } else {
          const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
          this.enquiryFormValidate.emailValid = !emailReg.test(email);
        }
        // if (membershipNo && membershipNo.length !== 19) {
        //   this.enquiryFormValidate.membershipNo = true;
        // }
        // const token = grecaptcha.enterprise.getResponse(this.recaptchaWidgetId);
        // if (!token) {
        //   this.enquiryFormValidate.recaptcha = true;
        // }
        const allPass = Object.entries(this.enquiryFormValidate).every(([, value]) => !value);
        if (!allPass) return;

        const params = {
          userId: this.userInfo.userId,
          sessionId: this.userInfo.sessionId,
          submitGroupCode: 2,
          programName: 'Visa Canada',
          operatingSystem: 'web',
          lang: this.$i18n.locale,
          reason,
          enReason,
          enquiry,
          email,
          firstName: this.userInfo.firstName,
          lastName: this.userInfo.lastName,
          subject,
          enSubject,
          // membershipNumber: membershipNo,
          fileLinkList: attachment.map(i => i.blobName),
        };
        this.$http.common.freshDeskSubmit(params).then(res => {
          if (res.state === '11') {
            this.successModalVisible = true;
          } else {
            this.failModalVisible = true;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
